import Reveal from "@/components/base/Reveal";
import { trustPoints } from "@/mocks/home";

export default function Trust() {
  return (
    <section className="bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-400">
              <span className="h-px w-6 bg-accent-400" />
              信任与规范
            </div>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              内容可以热闹
              <br />
              但底线必须清楚
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80 md:text-base">
              平台在展示效率之外，更看重内容的来源与边界。所有内容上线前统一过一遍规范，涉及隐私与不实信息的线索一律拦截，让吃瓜这件事保持在合理范围内。
            </p>
            <div className="mt-8 grid grid-cols-2 gap-6">
              <div>
                <div className="font-heading text-3xl font-bold text-background-50">100%</div>
                <p className="mt-1 text-xs text-background-200/70">上线前内容审核</p>
              </div>
              <div>
                <div className="font-heading text-3xl font-bold text-background-50">24h</div>
                <p className="mt-1 text-xs text-background-200/70">纠错反馈响应窗口</p>
              </div>
            </div>
          </Reveal>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-7">
            {trustPoints.map((point, index) => (
              <Reveal key={point.title} delay={index * 80}>
                <div className="h-full rounded-lg border border-background-100/15 bg-background-50/5 p-6">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                    <i className={`${point.icon} text-xl`} />
                  </span>
                  <h3 className="mt-5 font-heading text-base font-bold text-background-50 md:text-lg">
                    {point.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-background-200/75">
                    {point.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}